import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../login/login.css';
import logo1 from '../../../assets/images/logo.jpeg';

import configrations from '../../../config/configrations';


const VerifyOTP = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [otp, setOtp] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const email = location.state?.email;

  const handleInputChange = (e) => {
    setOtp(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let email = localStorage.getItem("password-reset-username");
    try {
      // const response = await fetch('http://localhost:5000/api/users/verify-otp', {
        const response = await fetch(`${configrations.backendBaseUrl}/api/users/verify-otp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email, otp })
      });
   console.log(email)
      const result = await response.json();

      if (response.ok) {
        navigate('/reset-password', { state: { email } });
      } else {
        setErrorMessage(result.message || 'An error occurred');
      }
    } catch (error) {
      setErrorMessage('Failed to verify OTP.');
    }
  };

  return (
    <div className="login-body">
      <div className="login-container">
        <section className="info">
          <section className="commpany-logo" style={{ backgroundImage: `url(${logo1})` }}></section>
          <h4>Welcome to</h4>
          <h2>BR Ambedkar Fund</h2>
        </section>
        <section className="login-form">
          <h2 className="text-center mt-4" style={{fontFamily:'algerian'}}>Verify OTP</h2>
          <form onSubmit={handleSubmit} className="m-3">
            <div className="mt-4">
              <label className="login-form-label" htmlFor="otp" style={{fontFamily:'algerian'}}>OTP</label>
              <input
                type="text"
                id="otp"
                name="otp"
                value={otp}
                onChange={handleInputChange}
                required
                autoComplete="off"
                className="form-control"
              />
              {errorMessage && <p className="text-danger">{errorMessage}</p>}
            </div>
            <div className="login-button-container">
              <button className="login-button" type="submit">Verify OTP</button>
            </div>
          </form>
        </section>
      </div>
    </div>
  );
};

export default VerifyOTP;
